'use client';

import CurriculumModule from '@/components/course-curriculum/curriculum-module';
import {
  useFilteredCurriculumByBatchVisibility,
  useGetBatchCurriculumVisibility,
} from '@/hooks/use-batch-curriculum-visibility';
import { Button } from '@/ui';
import { CourseViewModel } from '@hidayahlab/academy-suite-corelib';
import { DownArrowIcon } from '@tajdid/tajdid-ui/icons';
import { useState } from 'react';

type ModuleProps = {
  courseDetails: CourseViewModel;
  isEnrolled: boolean;
  batchId?: number;
};

export default function CourseDetailsCurriculum({
  courseDetails,
  isEnrolled,
  batchId,
}: ModuleProps) {
  const [show, setShow] = useState(false);
  const totalModules = courseDetails?.curriculum?.length ?? 0;
  const curriculums = courseDetails?.curriculum?.filter(
    item => item.contents.length > 0,
  );
  const { data: visibilityData } = useGetBatchCurriculumVisibility(batchId);

  const filteredCurriculumContents = useFilteredCurriculumByBatchVisibility(
    curriculums ?? [],
    visibilityData,
  );

  const filteredCurriculum =
    courseDetails.format === 'LIVE' ? filteredCurriculumContents : curriculums;

  return (
    <div className="flex flex-col gap-4">
      {filteredCurriculum
        ?.slice(0, show ? undefined : 3)
        .map((item, index) => (
          <CurriculumModule
            courseId={courseDetails.id}
            courseFormat={courseDetails.format}
            moduleIndex={index}
            key={item.id}
            curriculum={item}
            isEnrolled={isEnrolled}
            showResource={false}
            showActivity={false}
          />
        ))}
      {totalModules > 3 && (
        <Button
          onClick={() => setShow(!show)}
          variant="ghost"
          icon={<DownArrowIcon className={`${show && 'rotate-180'}`} />}
          iconPosition="end"
        >
          {!show
            ? ` show more
            ${totalModules - 3}
            `
            : 'show less'}
        </Button>
      )}
    </div>
  );
}
